import Vue from 'vue'

interface IUploadPayload {
  file?: File,
  images?: Blob[]
}

export async function uploadHandler(payload: IUploadPayload, bizToken: string) {
  const body = new FormData()
  if (payload.images) {
    for (const [index, image] of payload.images.entries()) {
      const imageSuffix = image.type === 'image/webp' ? 'webp' : 'jpeg'
      body.append('imageList', image, `out${index + 1}.${imageSuffix}`)
    }
  }

  if (payload.file) {
    body.append('video', payload.file)
  }
  body.append('token', bizToken)

  const { data } = await Vue.prototype.$http.post(
    '/liveness/h5/v1/detection',
    body,
    {
      headers: {'Content-Type': 'multipart/form-data'},
    })

  return data
}
